import {SITE_URL} from '@util/URLUtils';
import Icon from '@components/common/Icon';
import {Message, Button} from '@ultradent/components';
import ProgressBar from '@components/registration/ProgressBar';

const AccountRequiresVerification = ( props, context ) =>
    <div>

        <ProgressBar step={'3'} completed={[1, 1, 0]} labels={['create login', 'office details', 'verify account']}
                     isSubmitted={props.location.state.isSubmitted}/>

        <h1 className="leading-tight font-light text-center text-2xl md:text-4xl mx-auto">Almost Done!</h1>
        <h3 className="leading-tight font-normal text-center regSubHeading md:text-xl mx-auto">We still need to review
            your account information for accuracy.</h3>
        <div className="leading-tight universalForm-container my-4 md:my-12 mx-auto">
            {context.state.signUpError &&
                <Message notice
                         className="flex font-normal items-center -ml-4 -mr-4 md:-ml-8 md:-mr-8 px-4 md:px-8 py-4 text-white w-auto mb-4">
                    <Icon.ui wrapperClassName="mr-2" className="text-white text-xl"
                             name="report-problem-triangle"/>
                    <span
                        className="message-bar-msg">There was an error submitting this request, please try again.</span>
                </Message>
            }
            <Icon.ui
                className="text-5xl"
                wrapperClassName="justify-center"
                center
                name="user-pending"
            />
            <h2 className="text-center text-2xl">Account Pending</h2>
            <p className="text-center my-4"><strong>Ultradent only sells products to licensed dental professionals
                .</strong></p>
            <p className="text-center"><strong>Please allow 2-3 business days</strong> while a customer
                representative reviews the information provided for accuracy. Once completed, you will receive an email
                from <strong>info@ultradent.com</strong> with a link to verify your email address and complete your
                account activation.</p>
            <p className="mt-8 text-center font-normal mx-auto">Also, be sure to <strong>sign up for the Ultradent
                Newsletter</strong> to receive extra promotions and more!</p>
            <p className="my-4 text-center text-lg">{props.location.state.emailAddress}</p>
            <Button onClick={!context.state.signUpSuccess ? context.signUp : null}
                    className={`full ${context.state.signUpSuccess ? 'success' : 'primary'}`}
                    loading={context.state.signUpLoading}
                    disabled={context.state.signUpSubmitting}>
                {context.state.signUpSuccess ? 'Thank You!' : 'Yes, sign me up!'}
            </Button>

            <div className="text-center">
                <a href={SITE_URL} className="block full link-2 mt-12">
                    Start Shopping
                </a>
            </div>
        </div>
    </div>;

export default AccountRequiresVerification;